(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PixelText", [], factory);
	else if(typeof exports === 'object')
		exports["PixelText"] = factory();
	else
		root["PixelText"] = factory();
})(window, function() {
return 